
<!--US Page-->
<div class="dtfinsurance" *ngIf="!isCanadaPortal">
  
  <!--Banner-->
  <section class="mbfs-home-hero_2"
    style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Dynamic_Lease_Carousel_1140x400_1123.jpg);">
    <section class="mbfs-home-hero_2__header">
       <h2 class="mbfs-home-hero_2__header-subtitle" style="text-align: center;">
          {{ 'ConnectInsuranceLead.title' | translate }}
        </h2>
        <button style="text-align: justify; margin-right: 30px;" class="mbfs-button" (click)="Landingpage()">Learn More</button>
      <div class="shortrow">
        <div>
      </div>
       <br>
        <div class="dtf-connectedinsuranceleadform"></div>
     </div>
     <br>
    </section>
  </section>
</div>
